module.exports = __webpack_public_path__ + "static/media/img-4.e2221b9a.png";